<template>

    <div class="star-rating" :style="{
        'font-size': `${size}px`,
    }">
        <span v-if="!hasEmptyStars" :style="{ color: color, 'gap': `${gap}px` }">
            <i v-for="i in score" :key="'star-' + i" :class="{
                'fas fa-star': true,
            }" />
        </span>
        <span v-else :style="{ color: color, 'gap': `${gap}px` }">
            <i v-for="i in 5" :key="'star-' + i" :class="{
                'fas fa-star': i <= score,
                'far fa-star': i > score,
            }" />
        </span>
    </div>

</template>

<style scoped lang="scss">

    .star-rating {
        span {
            color: $color-gold;
            display: flex;
        }
    }

</style>

<script>

export default {

    props: {
        score: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
        },
        size: {
            type: Number,
            default: 15,
        },
        gap: {
            type: Number,
            default: 0,
        },
        hasEmptyStars: {
            type: Boolean,
            default: true,
        },
    },

}

</script>